import { Mock } from "../lib/appfuse-react/core/ajax";
import salesService from "../mock/sales";
import iamService from "../mock/iam";
import contentService from "../mock/content";
import qnrService from "../mock/qnr";
import caseInfoService from "../mock/caseInfo";
import screeningPrintService from "../mock/screeningPrint";
import collectionDateService from "../mock/collectionDate";
import testDateService from "../mock/testDate";
import testPrintService from "../mock/testPrint";
import updateLabNoService from "../mock/updateLabNo";
import institutionService from "../mock/institution";

const mock = (function() {
    const mock = new Mock();
    mock.use(iamService);
    mock.use(contentService);
    mock.use(salesService);
    mock.use(qnrService);
    mock.use(caseInfoService);
    mock.use(screeningPrintService);
    mock.use(collectionDateService);
    mock.use(testDateService);
    mock.use(testPrintService);
    mock.use(updateLabNoService);
    mock.use(institutionService);
    return mock;
}());

const context = {mock};

export default context;

export {mock};